module.exports = __webpack_public_path__ + "img/actas.8f53a8f4.svg";